export const restrictedMessage =
  'Your IP address indicates that you are in one of Flipster’s restricted\ncountries or regions. According to our terms of service, Flipster\ndoes not provide service in your location.';
